'use strict';

var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var propTypes = require('./prop-types.js');
var requiredParameter = require('./required-parameter.js');
var isFunction = require('./is-function.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultCompat(_toConsumableArray);

var _this = undefined;
/**
 * Promisify the passed function.
 *
 * @function
 * @param {Function} fn - Function to be promisified.
 * @returns {Function} Returns a new function promisified.
 * @example
 * const myFunction = callback => (isError ? callback(new Error()) : callback(null, result));
 * const myPromisifiedFunction = promisify(myFunction);
 * myPromisifiedFunction().then().catch();
 */

var promisify = function promisify() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requiredParameter('fn');

  if (isFunction(fn)) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new Promise(function (resolve, reject) {
        var argsToPass = args;

        var callback = function callback(error, result) {
          if (error) {
            return reject(error);
          }

          return resolve(result);
        };

        argsToPass.push(callback);
        fn.call.apply(fn, [_this].concat(_toConsumableArray__default["default"](argsToPass)));
      });
    };
  }

  throw new TypeError('Invalid parameter type: Function expected.');
};

promisify.HELPER_ID = 'Gearz.JsUtils.promisify';
promisify.returnType = propTypes.funcWithDescription('Returns a new function promisified.');
promisify.parameterTypes = {
  fn: propTypes.funcWithDescription('Function to be promisified.')
};
promisify.defaultParameters = {};

module.exports = promisify;
